/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { DownloadOptionDto, DownloadPageDto, DownloadRequestDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class DownloadClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Download
   * @name DownloadPost
   * @summary End point to get downloads.
   * @request POST:/Download
   */
  downloadPost = (data: DownloadRequestDto, params: RequestParams = {}) =>
    this.http.request<File, any>({
      path: `/Download`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Download
   * @name DownloadGetDownloadOptions
   * @summary Gets download options available for downloads.
   * @request GET:/Download/GetDownloadOptions
   */
  downloadGetDownloadOptions = (
    query?: {
      /** The DownloadPage instance. */
      downloadPage?: DownloadPageDto;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<DownloadOptionDto[], any>({
      path: `/Download/GetDownloadOptions`,
      method: "GET",
      query: query,
      format: "json",
      ...params,
    });
}
